<template>
  <div>
    <el-card
      class="left-box"
      body-style="height:calc(100vh - 150px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px"
      v-loading="loading"
    >
      <div
        style="
          height: 30px;
          margin-bottom: 10px;
          margin-top: 10px;
          width: 100%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          position: relative;
          justify-content: space-between;
        "
      >
        <div>
          <el-input
            style="width: 300px; margin-right: 10px"
            clearable
            v-model="searchData.DeviceName"
            placeholder="设备名称/编号"
          ></el-input>
          <el-radio-group
            v-model="searchData.State"
            @change="Search"
            style="margin-right: 10px"
          >
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">待审核</el-radio-button>
            <el-radio-button :label="2">已审核</el-radio-button>
            <el-radio-button :label="4">驳回</el-radio-button>
          </el-radio-group>

          <el-button type="primary" style="margin-left: 10px" @click="Search"
            >查询</el-button
          >
        </div>
        <div>
          <span class="Quantity">设备数量小计：{{ TotalQuantity }}</span>
          <span class="Quantity">设备数量总计：{{ SumQuantity }}</span>
        </div>
      </div>
      <div style="width: 100%">
        <el-table
          height="calc(100vh - 240px)"
          :data="dataList"
          @row-click="handleClick"
        >
          <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            label="设备编号"
            prop="device_no"
            align="center"
            sortable
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="设备名称"
            prop="device_name"
            align="center"
            sortable
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="设备规格"
            prop="specification"
            align="center"
            sortable
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="设备数量"
            prop="Num"
            align="right"
            sortable
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="安装日期"
            prop="purchase_date"
            align="center"
            sortable
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="填写人"
            prop="cVenName"
            align="center"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="生产厂家名称"
            prop="manufacturer"
            align="center"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="维修商名称"
            prop="maintenance"
            align="center"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
                label="提交人"
                prop="SubmitUserName"
                align="center"
                sortable
              >
              </el-table-column> -->
          <el-table-column
            label="提交日期"
            prop="SubmitTime"
            width="130"
            align="center"
            show-overflow-tooltip
            sortable
          >
            <template slot-scope="scope">
              {{ moment(scope.row.SubmitTime).format('YYYY-MM-DD') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Status"
            label="状态"
            align="center"
            width="130"
            sortable
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.Status == 1" type="warning"
                >{{ scope.row.Reviewer?.length == 1 ? '部分审核' : '待审核' }}
              </el-tag>
              <el-tag
                v-if="scope.row.Status == 2 || scope.row.Status == 3"
                type="success"
                >已审核
              </el-tag>
              <el-tag v-if="scope.row.Status == 4" type="danger">驳回 </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="审核人"
            prop="Reviewer"
            width="130"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag v-for="item in scope.row.Reviewer" :key="item">{{
                item
              }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </el-card>
    <ScheduleView ref="ScheduleView" @refresh="getDataList"></ScheduleView>
  </div>
</template>
<script>
import moment from 'moment'
import ScheduleView from '@/views/Project/Page/ProjectAudit/ScheduleView.vue'
export default {
  data() {
    return {
      moment,
      dataStatistics: {},
      dataList: [],
      searchData: {
        DeviceName: '',
        State: '',
      },
      loading: false,
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      backName: '',
      pId: '',
      SupplierId: '',
      devId: '',
      TotalQuantity: '',
      SumQuantity: '',
    }
  },
  props: {},
  components: { ScheduleView },
  methods: {
    handleClick(row) {
      this.$refs.ScheduleView.openDrawer(row)
    },
    handleBack() {
      this.$emit('toDom', 'ProjectAll')
    },
    Search() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    getDataList() {
      this.loading = true
      this.$http
        .post(`/Base_ProjectWork/Base_Project/GetProjectDeviceList`, {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SupplierId: this.SupplierId,
          ProjectId: this.pId,
          DeviceName: this.searchData.DeviceName,
          State: this.searchData.State,
          // DeviceType: this.devId,
          // Search: {
          //   ProjectId: this.pId,
          //   SupplierId: this.SupplierId,
          //   DeviceType: this.devId,
          //   ...this.searchData,
          // },
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.dataList = res.Data?.TableData || []
            this.TotalQuantity = res.Data.TotalQuantity || 0
            this.SumQuantity = res.Data.SumQuantity || 0
            this.pagination.total = res.Data?.Total || 0
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
  },
  mounted() {},
  created() {
    this.pId = this.$route.query.id
    this.backName = window.localStorage.getItem('ProjectName') || ''
    this.devId = this.$route.query.devId
    this.SupplierId = this.$route.query.ParentId
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .left-box {
  .el-card__header {
    padding: 10px;
    border: none;
  }
}
::v-deep .con .number {
  color: #e6a23c;
}
.head {
  height: 70px;
  // border-bottom: 1px solid #ccc;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-pagination__total {
  font-weight: bold;
  font-size: 18px !important;
}
::v-deep .el-table__row {
  cursor: pointer;
}
.Quantity {
  font-weight: bold;
  font-size: 18px;
  margin-right: 20px;
  color: #606266;
}
</style>
